import * as Common from "../../commons/common";

export class SheetActivity {
  id: number
  student_id: number
  score: number
  saiten_completed: boolean
  page: number

  constructor(sheetActivity: any){
    this.id = sheetActivity.id;
    this.student_id = sheetActivity.student_id;
    this.score = sheetActivity.score;
    this.saiten_completed = sheetActivity.saiten_completed;
    this.page = sheetActivity.page
  }
}

export class Examinee {
  id: number
  student_code: string
  student_no: number
  student_name: string

  constructor(examinee: any){
    this.id = examinee.id;
    this.student_code = examinee.student_code;
    this.student_no = examinee.student_no;
    this.student_name = examinee.student_name;
  }
}

export class FieldActivity {
  id: number
  sheet_activity_id: number
  sheet_field_id: number
  score: number | null
  score_cache: number | null
  correct_state: number | null
  correct_state_cache: number | null
  recog_text: string
  saiten_completed: boolean
  is_correct_changed: boolean
  is_correct_changed_cache: boolean
  sheetActivity: SheetActivity
  examinee: Examinee
  base64Image: string | null = null
  base64Canvas: string | null = null
  isCanvasEdited: boolean = false
  isStampEdited: boolean = false
  isTextEdited: boolean = false
  base64PreviewImages: string[] = []
  scoreStamps: ScoreStamp[]
  scoreStampCaches: ScoreStamp[]
  scoreStampIdx: number = 0
  tensakuTexts: TensakuText[]
  tensakuTextIdx: number = 0
  
  constructor(fieldActiviby: any, sheetActivities: any[], examinees: any[], base64CanvasHashArray: any[], page_count: number, score_stamps: any[], tensaku_texts: any[]){
    this.id = fieldActiviby.id;
    this.sheet_activity_id = fieldActiviby.sheet_activity_id;
    this.sheet_field_id = fieldActiviby.sheet_field_id;
    // 未採点は○×順ソート用に-1を設定
    this.score = fieldActiviby.score == null ? -1 : fieldActiviby.score;
    this.score_cache = fieldActiviby.score == null ? -1 : fieldActiviby.score;
    this.correct_state = fieldActiviby.correct_state;
    this.correct_state_cache = fieldActiviby.correct_state;
    this.recog_text = fieldActiviby.recog_text;
    this.saiten_completed = fieldActiviby.saiten_completed;
    this.is_correct_changed = fieldActiviby.is_correct_changed;
    this.is_correct_changed_cache = fieldActiviby.is_correct_changed;
    this.sheetActivity = new SheetActivity(sheetActivities.filter((x: any) => x.id == this.sheet_activity_id)[0]);
    this.examinee = new Examinee(examinees.filter((x: any) => x.student_no == this.sheetActivity.student_id)[0]);
    this.scoreStamps = score_stamps.filter((x: any) => x.field_activity_id == fieldActiviby.id).map((x: any) => {
      const scoreStamp = new ScoreStamp();
      scoreStamp.idx = this.scoreStampIdx++;
      scoreStamp.score = x.score;
      scoreStamp.x = x.x;
      scoreStamp.y = x.y;
      scoreStamp.width = x.width;
      scoreStamp.height = x.height;
      scoreStamp.color = x.color;
      return scoreStamp;
    });

    this.scoreStampCaches = this.scoreStamps.map((x: any) => {
      const scoreStamp = new ScoreStamp();
      scoreStamp.idx = x.idx;
      scoreStamp.score = x.score;
      scoreStamp.x = x.x;
      scoreStamp.y = x.y;
      scoreStamp.width = x.width;
      scoreStamp.height = x.height;
      scoreStamp.color = x.color;
      return scoreStamp;
    });
    
    this.tensakuTexts = tensaku_texts.filter((x: any) => x.field_activity_id == fieldActiviby.id).map((x: any) => {
      const tensakuText = new TensakuText();
      tensakuText.id = x.id;
      tensakuText.field_activity_id = x.field_activity_id;
      tensakuText.text = x.text;
      tensakuText.idx = this.tensakuTextIdx++;
      tensakuText.font_size = x.font_size;
      tensakuText.line_height = x.line_height;
      tensakuText.color = x.color;
      tensakuText.x = x.x;
      tensakuText.y = x.y;
      tensakuText.width = x.width;
      tensakuText.height = x.height;
      tensakuText.direction = x.direction;
      return tensakuText;
    });

    const base64Canvas = base64CanvasHashArray.filter(x => x.field_activity_id == this.id);
    if(base64Canvas.length > 0){
      this.base64Canvas = base64Canvas[0].src;
    }
  }
}

export class ScoreStamp {
  idx: number
  field_activity_id: number
  score: number
  x: number
  y: number
  width: number
  height: number
  color: string
  isActive: boolean = false
}

export class TensakuText {
  id: number = null
  field_activity_id: number = null
  idx: number = null
  text: string = null
  color: string = null
  font_size: number = null
  line_height: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  direction: number = null
  base64_text: string = null
}

export class ParamFieldActivity {
  id: number
  sheet_activity_id: number
  score: number | null
  correct_state: number | null
  score_stamps: ScoreStamp[] = []
  tensaku_texts: ParamTensakuText[] = []

  constructor(fieldActivity: FieldActivity){
    this.id = fieldActivity.id;
    this.sheet_activity_id = fieldActivity.sheet_activity_id;
    this.score = fieldActivity.score == -1 ? null : fieldActivity.score;
    this.correct_state = fieldActivity.correct_state;
    this.score_stamps = fieldActivity.scoreStamps;
    this.tensaku_texts = fieldActivity.tensakuTexts.map(x => new ParamTensakuText(x));
  }
}

export class ParamTensakuText {
  id: number = null
  field_activity_id: number = null
  idx: number = null
  text: string = null
  color: string = null
  font_size: number = null
  line_height: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  direction: number = null

  constructor(x: TensakuText){
    this.id = x.id
    this.field_activity_id = x.field_activity_id
    this.idx = x.idx
    this.text = x.text
    this.color = x.color
    this.font_size = x.font_size
    this.line_height = x.line_height
    this.x = x.x
    this.y = x.y
    this.width = x.width
    this.height = x.height
    this.direction = x.direction;
  }
}

export class Sheet {
  id: number
  base_sheet_id: number
  name: string = ""
  course_code: string
  campus_code: string
  class_code: string
  subject_code: string
  allot: number
  page_count: number
  question_image_completed: boolean

  constructor(sheet: any){
    this.id = sheet.id;
    this.base_sheet_id = sheet.base_sheet_id;
    this.name = sheet.name;
    this.course_code = sheet.course_code;
    this.campus_code = sheet.campus_code;
    this.class_code = sheet.class_code;
    this.subject_code = sheet.subject_code;
    this.allot = sheet.allot;
    this.page_count = sheet.page_count;
    this.question_image_completed = sheet.question_image_completed;
  }
}

export class SheetField {
  id: number
  part1: string
  part2: string
  part3: string
  allot: number
  allotCache: number
  scoreAverage: number
  scoreRate: number
  isSaitenCompleted: boolean
  baseWidth: number
  baseHeight: number
  addition: string
  scoring_type: number
  page: number

  constructor(sheetField: any, buffSize: number){
    this.id = sheetField.id;
    this.part1 = sheetField.part1;
    this.part2 = sheetField.part2;
    this.part3 = sheetField.part3;
    this.allot = sheetField.allot;
    this.baseWidth = sheetField.rim ? sheetField.rim[2] + (buffSize * 2) : null;
    this.baseHeight = sheetField.rim ? sheetField.rim[3] + (buffSize * 2) : null;
    this.addition = sheetField.addition;
    this.scoring_type = sheetField.scoring_type;
    this.page = sheetField.page;
  }
}
